import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { Clock, Printer, Share2, Heart } from 'lucide-react';
import Baies from '../../../../assets/images/diet/RR36.jpg';
import { useLocation, useNavigate } from "react-router-dom";


const HeroDiet = () => {
 const navigate = useNavigate();
   const handleGoBack = () => {
    navigate("/diet-food-recette"); // Remplace "/recettes" par ta vraie route de liste
  };
  const location = useLocation();
  const recipe = location.state?.recipe;
console.log('recipe in detail', recipe)
  if (!recipe) {
    return <p>Aucune recette trouvée.</p>;
  }

    return (
      <> 
          <button
      onClick={handleGoBack}
      className="btn btn-outline-success"
      style={{
        marginBottom: "1rem",
        fontWeight: 500,
        borderRadius: "25px",
        padding: "8px 20px"
      }}
    >
      ← Retour 
    </button>

     <Card heigth={300} className="border-0 shadow-lg rounded overflow-hidden" >
      <Row  className="g-0">
        {/* Image en pleine hauteur */}
        <Col xs={12} sm={12} md={7} lg={7}>
          <Card.Img
            src={Baies}
            alt="Moussaka de Lentilles Végétarienne"
            style={{height:'300px'}}
            className="img-fluid h-100  object-fit-cover"
          />
        </Col>
    
        {/* Contenu texte */}
        <Col  xs={12} sm={12} md={5} lg={5}>
          <Card.Body className="d-flex flex-column h-100 p-4">
            {/* Titre */}
             <h1  className='fs-40 mb-5 d-flex c-4-color justify-content-center '> {recipe.category} </h1>
            <h2 className="fs-1 fw-bold mb-5 text-warning text-center">{recipe.name}</h2>
    
            {/* Catégories */}
           
            {/* Temps de préparation et Régime */}
            <div className="text-center mb-3">
              <p className="mb-1">
                <Clock size={18} className="me-2 text-primary" />
                <strong >Temps total :</strong> {recipe.preparationTime} min
              </p>
              <p > <strong> 💪 difficulté :</strong> {recipe.difficulty}</p>
            </div>
    
            {/* Valeurs nutritionnelles */}
            <div className=" p-3 rounded shadow-sm text-center mb-3">
              <h5 className="fw-bold mb-2">Valeur Nutritive</h5>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <Badge className=" fs-14" bg="dark"> 🔥 {recipe.totalNV.calories} kcal</Badge>
                <Badge className=" fs-14" bg="info"> 💪 {recipe.totalNV.protein} g Protéines</Badge>
                <Badge className=" fs-14" bg="warning"> 🍞 {recipe.totalNV.carbs} g Glucides</Badge>
                <Badge className=" fs-14" bg="danger"> 🥑 {recipe.totalNV.fats} g Graisses</Badge>
              </div>
            </div>
    
            {/* Description */}
            <p className="text-muted fs-16 text-center mb-3">{recipe.description}</p>
    
            {/* Actions (likes, impression, partage) */}
            <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center text-danger">
                <Heart size={22} className="me-2" />
                <span className="fw-semibold">5136 LIKES</span>
              </div>
              <div className="d-flex gap-3">
                <Printer size={22} className="text-secondary cursor-pointer" />
                <Share2 size={22} className="text-secondary cursor-pointer" />
              </div>
            </div>
          </Card.Body>
        </Col>
      </Row>
    </Card>
    
      </>
     
    )
}

export default HeroDiet